import Illustration from './Illustration';
import { QuarterTurn } from './Turns';
import { Vertical, Horizontal } from './Straights';
import { Package } from './Package';

export default Illustration;
export { QuarterTurn, Vertical, Horizontal, Package };
